module.exports = __webpack_public_path__ + "img/logoTemplusBranca.ac770fa4.png";